export default function isValidAddress(address) {
  return !!address
    && !!address?.line_1?.trim()?.length
    && !!address?.locality?.trim()?.length
    && !!address?.postal_code?.trim()?.length
    && !!address?.region?.trim()?.length;
}
